import {Col, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import LockedAccountForm from "../form/LockedAccountForm";
import MDButton from "../../components/MDButton";
import {getCustomerFamily, saveClientAccountMembershipMembers} from "../common/api/WebApi";

export default function ClientManageAccountMembers({show, accountMembership, client, handleClose, handleSave}) {

  const [context, setContext] = useContext(AppContext);
  const [siblingQuantity, setSiblingQuantity] = useState(0);
  const [memberAccounts, setMemberAccounts] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (accountMembership?.familyPass) {
      setSiblingQuantity(accountMembership?.accessUsers - 1);
    } else {
      setSiblingQuantity(accountMembership?.accessUsers);
    }
  }, [accountMembership]);

  const [familyMembers, setFamilyMembers] = useState([]);
  useEffect(() => {
    if (!client || !client?.guid) {
      return;
    }
    getCustomerFamily(client?.guid).then((resp) => {
      setFamilyMembers(resp?.familyMembers);
    })
  }, [client]);

  const saveClientMembershipFn = () => {
    let _req = {...accountMembership};
    _req.memberAccounts = memberAccounts;
    setSaving(true);
    saveClientAccountMembershipMembers(_req).then((resp) => {
      setSaving(false);
      handleSave();
    })
  }
  return (
    <Modal onHide={handleClose} size={'lg'} show={show}>
      <Modal.Header closeButton>
        <Modal.Title>{accountMembership.name} Memberships
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs={12}>
            <LockedAccountForm
              key={accountMembership}
              inventory={accountMembership}
              client={client}
              siblingQuantity={siblingQuantity}
              callback={(cb) => {
                setMemberAccounts(cb?.membershipMembers);
              }}
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <MDButton type="button" onClick={saveClientMembershipFn} color="info"
                  disabled={memberAccounts?.length === 0 || saving}>
          {saving ? 'Saving...' : 'Save'}
        </MDButton>
      </Modal.Footer>
    </Modal>
  );
}